import {
  identifyBrowserUser,
  clearBrowserUser,
  syncBrowserCompanyGroup,
} from "@graftus/events/client";
import type { BusinessData } from "@/types/businessData";

export type IdentifyOpenPanelOptions = {
  email?: string;
  name?: string;
  memberRole?: string;
  /** When true, sets profile property `view_as_admin` for OpenPanel. */
  viewAsAdmin?: boolean;
};

export function identifyOpenPanelUser(
  firebaseUid: string,
  businessUid: string | null,
  options?: IdentifyOpenPanelOptions,
): void {
  let firstName: string | undefined;
  let lastName: string | undefined;

  if (options?.name) {
    const parts = options.name.trim().split(/\s+/);
    firstName = parts[0];
    lastName = parts.length > 1 ? parts.slice(1).join(" ") : undefined;
  }

  const properties: Record<string, unknown> = {
    business_uid: businessUid ?? "",
  };
  if (options?.memberRole != null && options.memberRole !== "") {
    properties.member_role = options.memberRole;
  }
  // OpenPanel merges identify properties; omitting the key leaves stale `true` from view-as.
  properties.view_as_admin = options?.viewAsAdmin === true;

  identifyBrowserUser({
    profileId: firebaseUid,
    email: options?.email,
    firstName,
    lastName,
    properties,
  });
}

export function syncOpenPanelBusinessGroup(business: BusinessData): void {
  syncBrowserCompanyGroup({
    id: business.uid,
    name: business.name || business.business || business.title || business.uid,
    properties: {
      plan: business.plan ?? null,
      account_type: business.accountType ?? null,
      subscription_status: business.subscription?.status ?? null,
    },
  });
}

export function resetOpenPanelUser(): void {
  clearBrowserUser();
}
